/**
 * Единый источник данных для сайта SMART-KVADRAT.
 * Деятельность ведёт один специалист — Пушкарева Мария Викторовна.
 * Контактные данные берутся только из уже существующего проекта.
 */

const email = 'smart-kvadrat@yandex.ru';

module.exports = {
  email,
  siteUrl: 'https://smart-kvadrat.ru',

  person: {
    name: 'Пушкарева Мария Викторовна',
    shortName: 'Мария Пушкарева',
    initials: 'МП',
    role: 'Разработка программного обеспечения и управление IT-проектами',
    academic: 'Кандидат экономических наук, доцент',
    position:
      'Доцент кафедры «Системное программирование» Института естественных и точных наук ЮУрГУ',
    experience: 'Более 5 лет в разработке программного обеспечения и управлении IT-проектами',
  },

  navLinks: [
    { name: 'Главная', url: '/' },
    { name: 'Услуги', url: '/services' },
    { name: 'О специалисте', url: '/about' },
    { name: 'Контакты', url: '/contacts' },
  ],

  footerLinks: [
    { name: 'Главная', url: '/' },
    { name: 'Услуги', url: '/services' },
    { name: 'О специалисте', url: '/about' },
    { name: 'Контакты', url: '/contacts' },
    { name: 'Политика конфиденциальности', url: '/privacy' },
    { name: 'Обработка персональных данных', url: '/personal-data' },
  ],

  contacts: {
    email,
    location: 'Челябинск',
  },

  services: [
    {
      icon: 'code',
      title: 'Разработка сайтов',
      tagline: 'Современные адаптивные сайты, корпоративные сайты, лендинги и специализированные веб-решения.',
      description:
        'Проектирую и разрабатываю сайты, которые решают конкретную задачу бизнеса: от лаконичного лендинга до многостраничного корпоративного портала с интеграциями. Внимание к структуре, скорости, доступности и понятному пользовательскому пути.',
      features: [
        'Корпоративные сайты и порталы',
        'Лендинги и промо-страницы',
        'Каталоги и специализированные веб-решения',
        'Адаптивная вёрстка для любых устройств',
        'Базовое SEO и семантическая разметка',
      ],
      stack: ['JavaScript', 'TypeScript', 'React', 'Gatsby', 'HTML/CSS'],
    },
    {
      icon: 'phone',
      title: 'Мобильные приложения',
      tagline: 'Разработка мобильных приложений для Android и других платформ с современным интерфейсом.',
      description:
        'Создаю мобильные приложения с продуманным интерфейсом и понятной логикой. Прорабатываю сценарии пользователя, интеграцию с серверной частью и стабильную работу на распространённых устройствах.',
      features: [
        'Кроссплатформенная разработка',
        'Продуманный пользовательский интерфейс',
        'Интеграция с API и серверной частью',
        'Работа с данными и уведомлениями',
        'Подготовка к публикации в магазинах приложений',
      ],
      stack: ['Flutter', 'Dart', 'Android', 'REST API'],
    },
    {
      icon: 'cloud',
      title: 'Веб-сервисы',
      tagline: 'Проектирование и разработка современных веб-сервисов и цифровых решений под конкретные задачи.',
      description:
        'Разрабатываю серверную часть и веб-сервисы: от проектирования архитектуры и модели данных до готового продукта. Использую микросервисный подход там, где он действительно оправдан.',
      features: [
        'Проектирование архитектуры сервиса',
        'Разработка API и серверной логики',
        'Микросервисная архитектура',
        'Проектирование баз данных',
        'Интеграция с внешними системами',
      ],
      stack: ['Java', 'Spring Boot', 'Spring Cloud', 'PostgreSQL', 'Docker'],
    },
    {
      icon: 'kanban',
      title: 'Управление IT-проектами',
      tagline: 'Планирование, организация и сопровождение разработки программных продуктов — от постановки задачи до реализации.',
      description:
        'Беру на себя организацию работы над IT-продуктом: формулирую требования, декомпозирую задачи, выстраиваю этапы и контролирую результат. Это снижает риски срыва сроков и потери качества.',
      features: [
        'Сбор и формализация требований',
        'Планирование и декомпозиция задач',
        'Организация процесса разработки',
        'Контроль качества и сроков',
        'Документирование и сопровождение',
      ],
      stack: ['Анализ требований', 'Проектирование', 'Agile-подходы', 'Контроль качества'],
    },
    {
      icon: 'ai',
      title: 'AI в IT-проектах',
      tagline:
        'Использование современных технологий искусственного интеллекта для разработки, автоматизации, анализа и повышения эффективности IT-процессов.',
      description:
        'Применяю инструменты искусственного интеллекта на разных этапах работы — от генерации идей и прототипов до автоматизации рутинных операций и анализа данных. Это ускоряет разработку без потери контроля над результатом.',
      features: [
        'AI-ассистированная разработка',
        'Автоматизация повторяющихся процессов',
        'Анализ данных и подготовка решений',
        'Быстрое прототипирование',
        'Осознанная работа с ограничениями моделей',
      ],
      stack: ['LLM', 'Автоматизация', 'Машинное обучение', 'Промпт-инжиниринг'],
    },
    {
      icon: 'shield',
      title: 'Защита информации',
      tagline: 'Учёт требований информационной безопасности при проектировании и разработке программных решений.',
      description:
        'Информационная безопасность закладывается на этапе проектирования, а не добавляется в конце. Учитываю требования защиты данных, разграничения доступа и безопасной обработки персональных данных.',
      features: [
        'Безопасная архитектура решений',
        'Разграничение прав доступа',
        'Защита персональных данных',
        'Учёт требований законодательства РФ',
        'Безопасная работа с API и данными',
      ],
      stack: ['Информационная безопасность', 'Защита данных', 'Разграничение доступа'],
    },
  ],

  expertise: [
    {
      icon: 'academic',
      title: 'Академическая база',
      text: 'Кандидат экономических наук, доцент кафедры «Системное программирование» Института естественных и точных наук ЮУрГУ.',
    },
    {
      icon: 'experience',
      title: 'Практика более 5 лет',
      text: 'Разработка программного обеспечения и управление IT-проектами — от постановки задачи до работающего продукта.',
    },
    {
      icon: 'flow',
      title: 'Полный цикл',
      text: 'Сформулировать требования, спроектировать решение, организовать разработку, проконтролировать качество и довести проект до результата.',
    },
    {
      icon: 'ai',
      title: 'Современные технологии',
      text: 'Использование актуального стека и инструментов искусственного интеллекта для ускорения и повышения качества разработки.',
    },
    {
      icon: 'shield',
      title: 'Информационная безопасность',
      text: 'Учёт требований защиты информации и персональных данных на всех этапах работы над IT-проектом.',
    },
    {
      icon: 'mentor',
      title: 'Преподавательский опыт',
      text: 'Преподавание разработки, внедрения и сопровождения ПО в ЮУрГУ — системный и понятный подход к объяснению сложного.',
    },
  ],

  workflow: [
    {
      title: 'Анализ и требования',
      text: 'Разбираю задачу, уточняю цели и фиксирую требования — так появляется понятный образ результата.',
    },
    {
      title: 'Проектирование решения',
      text: 'Определяю архитектуру, структуру данных и интерфейсы, чтобы решение было надёжным и расширяемым.',
    },
    {
      title: 'Разработка',
      text: 'Реализую продукт поэтапно, с прозрачными сроками и промежуточной проверкой результата.',
    },
    {
      title: 'AI-инструменты',
      text: 'Подключаю искусственный интеллект для ускорения разработки, автоматизации и анализа.',
    },
    {
      title: 'Контроль качества',
      text: 'Проверяю сценарии, тестирую ключевые функции и слежу за качеством на каждом этапе.',
    },
    {
      title: 'Безопасность',
      text: 'Учитываю требования информационной безопасности и защиты персональных данных.',
    },
    {
      title: 'Запуск и сопровождение',
      text: 'Помогаю с запуском проекта и дальнейшими улучшениями после старта.',
    },
  ],

  colors: {
    darkNavy: '#080B16',
    navy: '#0D1426',
    blue: '#5670F6',
  },

  srConfig: (delay = 200, viewFactor = 0.2) => ({
    origin: 'bottom',
    distance: '24px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
